import { render, staticRenderFns } from "./Topic2Role.vue?vue&type=template&id=7aa6f97c&scoped=true"
import script from "./Topic2Role.vue?vue&type=script&lang=js"
export * from "./Topic2Role.vue?vue&type=script&lang=js"
import style0 from "./Topic2Role.vue?vue&type=style&index=0&id=7aa6f97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa6f97c",
  null
  
)

export default component.exports